<template>
  <div v-if="!isLoading">
    <div id="printSection">
      <!-- Contact -->
      <div class="grid">
        <div class="grid-title">
          <h4>{{ $t("_BOOKING_DETAIL.TITLE") }}</h4>
          <v-btn class="pl-5 pr-5" color="primary" v-if="!code" @click="back">
            {{ $t("BACK") }}
          </v-btn>
          <v-btn class="pl-5 pr-5" color="primary" v-if="code" @click="()=> {$emit('close')}">
            {{ $t("CLOSE") }}
          </v-btn>
        </div>
        <div class="grid-body p-3 border-top-unset">
          <div class="d-flex align-items-stretch">
            <div class="w-100">
              <v-card class="p-3 h-100 border" elevation="0">
                <label class="label-title mb-2">{{ $t("_BOOKING_DETAIL.CONTACT.TITLE") }}</label>
                <div class="pl-3">
                  <div class="booking-detail-info-wrapper">
                    <span class="booking-detail-label booking-detail-label-width text-primary">{{
                      $t("_BOOKING_DETAIL.CONTACT.NAME")
                    }}</span>
                    <span class="booking-detail-content">
                      {{ data.bookingCustomer.name }}
                    </span>
                  </div>
                  <div class="booking-detail-info-wrapper">
                    <span class="booking-detail-label booking-detail-label-width text-primary">{{
                      $t("_BOOKING_DETAIL.CONTACT.PHONE")
                    }}</span>
                    <span class="booking-detail-content">
                      {{ data.bookingCustomer.phone }}
                    </span>
                  </div>
                  <div class="booking-detail-info-wrapper">
                    <span class="booking-detail-label booking-detail-label-width text-primary">{{
                      $t("_BOOKING_DETAIL.CONTACT.EMAIL")
                    }}</span>
                    <span class="booking-detail-content">
                      {{ data.bookingCustomer.email }}
                    </span>
                  </div>
                  <div class="booking-detail-info-wrapper">
                    <span class="booking-detail-label booking-detail-label-width text-primary">{{
                      $t("COUNTRY")
                    }}</span>
                    <span class="booking-detail-content">
                      {{ data.bookingCustomer.country }}
                    </span>
                  </div>
                </div>
              </v-card>
            </div>
            <div class="w-100 ml-3" v-if="data.bookingTravelAgents.length > 0">
              <v-card class="p-3 h-100 border" elevation="0">
                <label class="label-title mb-2">{{ $t("CHAIN_TRAVEL_AGENT_INFOMATION") }}</label>
                <div class="pl-2">
                  <div class="booking-detail-info-wrapper">
                    <span class="booking-detail-label booking-detail-label-width text-primary">{{
                      $t("_TRAVEL_AGENT.NAME")
                    }}</span>
                    <span class="booking-detail-content">
                      {{ data.bookingTravelAgents[0].nameVi }}
                    </span>
                  </div>
                  <div class="booking-detail-info-wrapper">
                    <span class="booking-detail-label booking-detail-label-width text-primary">{{
                      $t("_BOOKING_DETAIL.CONTACT.EMAIL")
                    }}</span>
                    <span class="booking-detail-content">
                      {{ data.bookingTravelAgents[0].email }}
                    </span>
                  </div>
                </div>
              </v-card>
            </div>
            <div class="w-100 ml-3">
              <v-card class="p-3 h-100 border" elevation="0">
                <div>
                  <h5 class="mb-3">
                    {{ data.hotel.hotelI18n.find(x => x.lang == defaultI18n).name }}
                  </h5>
                  <p class="booking-detail-label booking-detail-label-width">
                    <v-icon size="20">location_on</v-icon>
                    {{ data.hotel.hotelI18n.find(x => x.lang == defaultI18n).address }},
                    {{
                      data.hotel.hotelI18n.find(x => x.lang == defaultI18n).location
                    }},
                    {{ data.hotel.hotelI18n.find(x => x.lang == defaultI18n).city }},
                    {{ data.hotel.hotelI18n.find(x => x.lang == defaultI18n).country }}
                  </p>
                  <p class="booking-detail-label booking-detail-label-width">
                    <v-icon size="20">call</v-icon> {{ data.hotel.phoneNumber }}
                  </p>
                  <p class="booking-detail-label booking-detail-label-width">
                    <v-icon size="20">email</v-icon>
                    {{ data.hotel.email }}
                  </p>
                  <p class="booking-detail-label booking-detail-label-width">
                    <v-icon size="20">schedule</v-icon>
                    {{ findTimeZone(data.timeZoneStr) }}
                  </p>
                </div>
              </v-card>
            </div>
          </div>
          <div class="mt-3">
            <v-card class="h-100 border" elevation="0">
              <label class="label-title mx-3 mt-3 mb-2">{{ $t("_BOOKING_DETAIL.BOOKING_DETAIL.TITLE") }}</label>
              <v-row class="mx-3">
                <v-col cols="6" class="pt-0">
                  <div class="booking-detail-info-wrapper">
                    <span class="booking-detail-label booking-detail-label-width text-primary">{{
                      $t("_BOOKING_DETAIL.BOOKING_DETAIL.CODE")
                    }}</span>
                    <span class="booking-detail-content text-green">
                      {{ data.bookingCode }}
                    </span>
                  </div>
                  <div class="booking-detail-info-wrapper">
                    <span class="booking-detail-label booking-detail-label-width text-primary">{{
                      $t("_BOOKING_DETAIL.BOOKING_DETAIL.OTACODE")
                    }}</span>
                    <span class="booking-detail-content text-green">
                      {{ data.otaBookingCode }}
                    </span>
                  </div>
                  <div class="booking-detail-info-wrapper">
                    <span class="booking-detail-label booking-detail-label-width text-primary">Payment collect</span>
                    <span class="booking-detail-content">
                      {{ data.paymentCollectType === 0 ? 'Property collect' : data.paymentCollectType === 1 ? 'OTA contact' : 'Channel collect' }}
                    </span>
                  </div>
                  <div class="booking-detail-info-wrapper">
                    <span class="booking-detail-label booking-detail-label-width text-primary">{{
                      $t("_BOOKING_DETAIL.BOOKING_DETAIL.STATUS")
                    }}</span>
                    <span class="booking-detail-content text-green" :style="{
                          color: listBookingStatus.find(
                            x => x.value == data.bookingStatus
                          ).color
                        }">{{
      listBookingStatus.find(x => x.value == data.bookingStatus)
        .text
    }}</span>
                  </div>
                  <div class="booking-detail-info-wrapper" v-if="data.bookingStatus === 2 || data.bookingStatus === 3">
                    <span class="booking-detail-label booking-detail-label-width text-primary">{{
                      $t("CANCEL_REASON")
                    }}</span>
                    <span class="booking-detail-content">
                      {{ data.cancellationReason }}
                    </span>
                  </div>
                  <div class="booking-detail-info-wrapper">
                    <span class="booking-detail-label booking-detail-label-width text-primary">{{
                      $t("SALE_CHANNEL")
                    }}</span>
                    <span class="booking-detail-content font-weight-bold">
                      {{ data.ota.otaI18n.find(x => x.lang == defaultI18n).name }}
                    </span>
                  </div>
                  <div class="booking-detail-info-wrapper" v-if="data.otaCode == 'EZ_BE'">
                    <span class="booking-detail-label booking-detail-label-width text-primary">
                      {{ $t('INVOICE_REQUEST') }}
                    </span>
                    <span class="booking-detail-content" v-if="data.bookingInvoices.length == 0">{{ $t('_ACTIVITY.NO') }}</span>
                    <span class="booking-detail-content d-flex" v-else>
                      <span class="mr-1">{{ $t('_ACTIVITY.YES') }}</span>
                      <span 
                        class="text-primary pointer" 
                        @click="toogleShowInvoice = !toogleShowInvoice"
                      >
                        {{ toogleShowInvoice ? $t('HIDE_INFORMATION') : $t('SHOW_INFORMATION') }}
                      </span>
                    </span>
                  </div>
                  <template v-if="data.bookingInvoices.length > 0 && toogleShowInvoice && data.otaCode == 'EZ_BE'">
                    <div class="booking-detail-info-wrapper">
                      <span class="booking-detail-label booking-detail-label-width text-primary">
                        {{$t('COMPANY_NAME_OR_BOOKER')}}
                      </span>
                      <span class="booking-detail-content">{{ data.bookingInvoices[0].nameVi }}</span>
                    </div>
                    <div class="booking-detail-info-wrapper">
                      <span class="booking-detail-label booking-detail-label-width text-primary">
                        {{ $t('_REGISTER.TAX_CODE') }}
                      </span>
                      <span class="booking-detail-content">{{ data.bookingInvoices[0].taxCode }}</span>
                    </div>
                    <div class="booking-detail-info-wrapper">
                      <span class="booking-detail-label booking-detail-label-width text-primary">
                        {{ $t('_BOOKING_DETAIL.CONTACT.EMAIL') }}
                      </span>
                      <span class="booking-detail-content">{{ data.bookingInvoices[0].email }}</span>
                    </div>
                    <div class="booking-detail-info-wrapper">
                      <span class="booking-detail-label booking-detail-label-width text-primary">
                        {{ $t('_REGISTER.ADDRESS') }}
                      </span>
                      <span class="booking-detail-content">{{ data.bookingInvoices[0].address }}</span>
                    </div>
                    <div class="booking-detail-info-wrapper">
                      <span class="booking-detail-label booking-detail-label-width text-primary">
                        {{ $t('_BOOKING_DETAIL.BOOKING_DETAIL.NOTE') }}
                      </span>
                      <span class="booking-detail-content" v-html="data.bookingInvoices[0].description"></span>
                    </div>
                  </template>
                  <div class="booking-detail-info-wrapper" v-if="data.otaCode == 'EZ_BE'">
                    <span class="booking-detail-label booking-detail-label-width text-primary">
                      {{ $t('INVOICE_REQUEST') }}
                    </span>
                    <span class="booking-detail-content" v-if="data.bookingInvoices.length == 0">{{ $t('_ACTIVITY.NO') }}</span>
                    <span class="booking-detail-content d-flex" v-else>
                      <span class="mr-1">{{ $t('_ACTIVITY.YES') }}</span>
                      <span 
                        class="text-primary pointer" 
                        @click="toogleShowInvoice = !toogleShowInvoice"
                      >
                        {{ toogleShowInvoice ? $t('HIDE_INFORMATION') : $t('SHOW_INFORMATION') }}
                      </span>
                    </span>
                  </div>
                  <template v-if="data.bookingInvoices.length > 0 && toogleShowInvoice && data.otaCode == 'EZ_BE'">
                    <div class="booking-detail-info-wrapper">
                      <span class="booking-detail-label booking-detail-label-width text-primary">
                        {{$t('COMPANY_NAME_OR_BOOKER')}}
                      </span>
                      <span class="booking-detail-content">{{ data.bookingInvoices[0].nameVi }}</span>
                    </div>
                    <div class="booking-detail-info-wrapper">
                      <span class="booking-detail-label booking-detail-label-width text-primary">
                        {{ $t('_REGISTER.TAX_CODE') }}
                      </span>
                      <span class="booking-detail-content">{{ data.bookingInvoices[0].taxCode }}</span>
                    </div>
                    <div class="booking-detail-info-wrapper">
                      <span class="booking-detail-label booking-detail-label-width text-primary">
                        {{ $t('_BOOKING_DETAIL.CONTACT.EMAIL') }}
                      </span>
                      <span class="booking-detail-content">{{ data.bookingInvoices[0].email }}</span>
                    </div>
                    <div class="booking-detail-info-wrapper">
                      <span class="booking-detail-label booking-detail-label-width text-primary">
                        {{ $t('_REGISTER.ADDRESS') }}
                      </span>
                      <span class="booking-detail-content">{{ data.bookingInvoices[0].address }}</span>
                    </div>
                    <div class="booking-detail-info-wrapper">
                      <span class="booking-detail-label booking-detail-label-width text-primary">
                        {{ $t('_BOOKING_DETAIL.BOOKING_DETAIL.NOTE') }}
                      </span>
                      <span class="booking-detail-content" v-html="data.bookingInvoices[0].description"></span>
                    </div>
                  </template>
                </v-col>
                <v-divider vertical style="margin: 0 -1px!important"></v-divider>
                <v-col cols="6" class="pt-0">
                  <div class="booking-detail-info-wrapper">
                    <span class="booking-detail-label booking-detail-label-width text-primary">{{
                      $t("_BOOKING_DETAIL.BOOKING_DETAIL.CREATED")
                    }}</span>
                    <span class="booking-detail-content">
                      {{ formatDateTime(data.createdDate) }}
                    </span>
                  </div>
                  <div class="booking-detail-info-wrapper">
                    <span class="booking-detail-label booking-detail-label-width text-primary">{{
                      $t("_BOOKING.TIME_STAY")
                    }}</span>
                    <span class="booking-detail-content">
                      <template v-if="sysLang == 'vi'">
                        {{
                          _formatDateTime(
                            data.arrival,
                            "YYYY-MM-DD",
                            "DD/MM/YYYY"
                          ) +
                          " - " +
                          _formatDateTime(
                            data.departure,
                            "YYYY-MM-DD",
                            "DD/MM/YYYY"
                          )
                        }}
                      </template>
                      <template v-else>
                        {{
                          _formatDateTime(
                            data.arrival,
                            "YYYY-MM-DD",
                            "YYYY/MM/DD"
                          ) +
                          " - " +
                          _formatDateTime(
                            data.departure,
                            "YYYY-MM-DD",
                            "YYYY/MM/DD"
                          )
                        }}
                      </template>
                    </span>
                  </div>
                  <div class="booking-detail-info-wrapper">
                    <span class="booking-detail-label booking-detail-label-width text-primary">{{
                      $t("NIGHT_NUMBER")
                    }}</span>
                    <span class="booking-detail-content">
                      {{ $tc('NIGHT_CAP', data.nights) }}
                    </span>
                  </div>
                  <div class="booking-detail-info-wrapper">
                    <span class="booking-detail-label booking-detail-label-width text-primary">{{
                      $t("_BOOKING_DETAIL.BOOKING_DETAIL.NOTE")
                    }}</span>
                    <span class="booking-detail-content comment-content" style="line-height: 1.5;">{{ data.comment }}</span>
                  </div>
                </v-col>
              </v-row>
              <div class="">
                <div class="headertableDetail px-3">
                  <b-row class="text-secondary m-0">
                    <b-col md="4" class="pt-0 pb-0 pl-0">
                      <v-row>
                        <v-col>
                          <span class="font-weight-bold text-uppercase">{{
                            $t("ROOM_INFOMATION")
                          }}</span>
                        </v-col>
                      </v-row>
                    </b-col>
                    <b-col class="p-0">
                      <b-row>
                        <b-col><span class="font-weight-bold text-uppercase">{{
                          $t("DETAIL")
                        }}</span></b-col>
                        <b-col cols="2" class="text-center"><span class="font-weight-bold text-uppercase">{{
                            $t("STATUS")
                          }}</span></b-col>
                        <b-col class="text-right" cols="2"><span class="font-weight-bold text-uppercase">{{
                          $t("NIGHT")
                        }}</span></b-col>
                        <b-col class="text-right" cols="2"><span class="font-weight-bold text-uppercase">{{
                          $t("PRICE")
                        }}</span></b-col>
                        <b-col class="text-right" cols="2"><span class="font-weight-bold text-uppercase">{{
                          $t("_BOOKING_DETAIL.SERVICE.COUNT")
                        }}</span></b-col>
                        <b-col class="text-right" style="padding-left: 0" cols="2"><span
                            class="font-weight-bold text-uppercase">{{
                              $t("_BOOKING_DETAIL.SUB_TOTAL")
                            }}</span></b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </div>
                <p class="border-bottom"></p>
                <div class="px-3" v-for="(rateplanid, index) in bookingGroup" :key="index">
                  <div class="item-rateplan">
                    <div v-for="(item, ind) in data.bookingLines.filter(
                      x => x.ratePlan.id == rateplanid && x.bookingLineType == 0
                    )">
                      <b-row class="m-0 mb-3">
                        <b-col class="p-0" md="4">
                          <p class="m-0 fs-16">
                            <span class="font-weight-bold">{{ $t("ROOM") }}: {{ item.description }}</span><br />
                            <span class="text-secondary fs-12">({{ item.title }})<br /></span>
                            <span class="m-0" v-if="item.guestName">{{ $t("GUEST_NAME") }}: {{ item.guestName }}</span>
                          </p>
                          <p class="m-0">
                            {{ $t("_BOOKING_DETAIL.SERVICE.COUNT") }}:
                            {{ item.adults }} {{ $t("_BOOKING_DETAIL.ROOM.ADULTS") }},
                            {{ item.children }}
                            {{ $t("_BOOKING_DETAIL.ROOM.CHILDREN") }}, {{ item.baby }}
                            {{ $t("_BOOKING_DETAIL.ROOM.BABY") }}
                          </p>
                          <div class="d-flex" v-if="item.specialRequest">
                            <p class="m-0 text-truncate pr-5 w-70">{{
                              $t('_BOOKING_DETAIL.BOOKING_DETAIL.NOTE')
                            }}:
                              {{ item.specialRequest }}</p>
                            <b-btn variant="text" class="p-0 text-primary" @click="openPopupNote(item.specialRequest)">{{
                              $t('SHOW_MORE') }}</b-btn>
                          </div>
                        </b-col>
                        <b-col class="p-0">
                          <b-row class="mt-0">
                            <b-col cols="2" class="pt-0 pb-0 d-flex">
                              <span class="text-nowrap">{{ $t("UNIT_ROOM_PRICE") }}</span> <v-icon color="primary" dark class="pl-2 pr-10"
                                size="18" :id="rateplanid + ind + index">
                                info
                              </v-icon>
                              <b-popover :target="rateplanid + ind + index" triggers="hover focus">
                                <template #title>{{ $t('DETAIL') }}</template>
                                <div class="description-price">
                                  <div v-for="(i, index) in groupBy(item.bookingRates, 'appliedDate')" :key="index">
                                    <strong>
                                      <template v-if="sysLang == 'vi'">
                                        {{ _formatDateTime(i[0].appliedDate, "YYYY-MM-DD", "DD/MM/YYYY") }}
                                      </template>
                                      <template v-else>
                                        {{ _formatDateTime(i[0].appliedDate, "YYYY-MM-DD", "DD/MM/YYYY") }}
                                      </template>
                                    </strong>
                                    : <ul>
                                      <li>{{ $t("UNIT_ROOM_PRICE") }}: &nbsp; {{ sumPrice(i, 'pricePax') }}</li>
                                      <li>{{ $t("INCLUDE_COMMISSION_RATE") }}: &nbsp; {{ sumPrice(i, 'pricePaxAfterCommission') }}</li>
                                      <li>{{ $t("EXCLUDE_COMMISSION_RATE") }}: &nbsp; {{ sumPrice(i, 'pricePaxBeforeCommission') }}</li>
                                      <li v-if="!isNaN(sumPrice(i, 'priceExtraAdult')) && sumPrice(i, 'priceExtraAdult') > 0">
                                        {{ $t("priceExtraAdult") }}: &nbsp; {{ sumPrice(i, 'priceExtraAdult')}}
                                      </li>
                                      <li v-if="!isNaN(sumPrice(i, 'priceExtraChild')) && sumPrice(i, 'priceExtraChild') > 0">
                                        {{ $t("priceExtraChild") }}: &nbsp; {{ sumPrice(i, 'priceExtraChildren') }}
                                      </li>
                                      <li v-if="!isNaN(sumPrice(i, 'priceExtraBaby')) && sumPrice(i, 'priceExtraBaby') > 0">
                                        {{ $t("priceExtraBaby") }}: &nbsp; {{ sumPrice(i, 'priceExtraBaby') }}
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </b-popover>
                            </b-col>
                            <b-col class="pt-0 pb-0 text-center" cols="2"><span>{{
                                roomStatus(item.bookingLineStatus)
                              }}</span></b-col>
                            <b-col class="pt-0 pb-0 text-right" cols="2"><span>{{
                              item.nights
                            }}</span></b-col>
                            <b-col class="pt-0 pb-0 text-right" cols="2"><span>{{
                              formatCurrency(+item.unitPrice)
                            }}</span></b-col>
                            <b-col class="pt-0 pb-0 text-right" cols="2"><span>{{ item.quantity }}</span></b-col>
                            <b-col class="pt-0 pb-0 text-right" cols="2"><span>{{
                              formatCurrency(item.amountPax)
                            }}</span></b-col>
                          </b-row>
                          <template v-if="item.serviceStatic.length > 0">
                            <span>{{ $t('SERVICE_INCLUDES') }}</span> <v-icon color="primary" dark
                              class="pl-2 pr-10 cursor" size="18" :id="rateplanid + ind + index + 'svStatic'">
                              info
                            </v-icon>
                            <b-popover :target="rateplanid + ind + index + 'svStatic'" triggers="hover focus">
                              <template #title>{{ $t('DETAIL') }}</template>
                              <div class="description-price pr-3">
                                <div v-for="(sv, indsv) in item.serviceStatic" :key="indsv">
                                  <b>{{ sv.name }}</b> ( x {{ sv.quantity }})
                                  <ul>
                                    <li v-for="(i, index) in sv.bookingServiceRates" :key="index">
                                      <template v-if="sysLang == 'vi'">
                                        {{ _formatDateTime(i.appliedDate, "YYYY-MM-DD", "DD/MM/YYYY") }}
                                      </template>
                                      <template v-else>
                                        {{ _formatDateTime(i.appliedDate, "YYYY-MM-DD", "DD/MM/YYYY") }}
                                      </template>
                                      : &nbsp; {{ formatCurrency(+i.price) }}
                                    </li>
                                  </ul>

                                </div>
                              </div>
                            </b-popover>
                          </template>
                          <b-row v-if="item.extraAdults > 0" class="mt-0">
                            <b-col class="pt-0 pb-0"><span>{{ $t("priceExtraAdult") }}</span></b-col>
                            <b-col class="pt-0 pb-0 text-right" cols="4"><span>{{
                              formatCurrency(
                                +item.amountExtraAdult / +item.extraAdults
                              )
                            }}</span></b-col>
                            <b-col class="pt-0 pb-0 text-right" cols="2"><span>{{ item.extraAdults }}</span></b-col>
                            <b-col class="pt-0 pb-0 text-right" cols="2"><span>{{
                              formatCurrency(item.amountExtraAdult)
                            }}</span></b-col>
                          </b-row>
                          <b-row v-if="item.extraChildren > 0" class="mt-0">
                            <b-col class="pt-0 pb-0"><span>{{ $t("priceExtraChild") }}</span></b-col>
                            <b-col class="pt-0 pb-0 text-right" cols="4"><span>{{
                              formatCurrency(
                                +item.amountExtraChildren / +item.extraChildren
                              )
                            }}</span></b-col>
                            <b-col class="pt-0 pb-0 text-right" cols="2"><span>{{ +item.extraChildren }}</span></b-col>
                            <b-col class="pt-0 pb-0 text-right" cols="2"><span>{{
                              formatCurrency(item.amountExtraChildren)
                            }}</span></b-col>
                          </b-row>
                          <b-row v-if="item.extraBaby > 0" class="mt-0">
                            <b-col class="pt-0 pb-0"><span>{{ $t("priceExtraBaby") }}</span></b-col>
                            <b-col class="pt-0 pb-0 text-right" cols="4"><span>{{
                              formatCurrency(
                                +item.amountExtraBaby / +item.extraBaby
                              )
                            }}</span></b-col>
                            <b-col class="pt-0 pb-0 text-right" cols="2"><span>{{ +item.extraBaby }}</span></b-col>
                            <b-col class="pt-0 pb-0 text-right" cols="2"><span>{{
                              formatCurrency(item.amountExtraBaby)
                            }}</span></b-col>
                          </b-row>
                          <!-- <div v-for="promotion in data.bookingLines.filter( y => y.ratePlan.id == item.ratePlan.id && x.bookingLineType == 1)"> -->
                          <template v-if="item.bookingServices.length > 0">
                            <template v-for="(sv, indexsv) in item.bookingServices">
                              <b-row v-if="sv.serviceType !== 1" class="mt-0">
                                <b-col class="pt-0 pb-0"><span>{{ sv.name }}</span> <v-icon color="primary" dark
                                    class="pl-2 pr-10 cursor" size="18" :id="rateplanid + sv.serviceCode + indexsv + ind"
                                    v-if="sv.bookingServiceRates.length > 0">
                                    info
                                  </v-icon>
                                  <b-popover :target="rateplanid + sv.serviceCode + indexsv + ind" triggers="hover focus"
                                    v-if="sv.bookingServiceRates.length > 0">
                                    <template #title>{{ $t('DETAIL') }}</template>
                                    <div class="description-price">
                                      <div v-for="(i, index) in sv.bookingServiceRates" :key="index">
                                        <template v-if="sysLang == 'vi'">
                                          {{ _formatDateTime(i.appliedDate, "YYYY-MM-DD", "DD/MM/YYYY") }}
                                        </template>
                                        <template v-else>
                                          {{ _formatDateTime(i.appliedDate, "YYYY-MM-DD", "DD/MM/YYYY") }}
                                        </template>
                                        : &nbsp; {{ formatCurrency(+i.price) }}
                                      </div>
                                    </div>
                                  </b-popover>
                                  <br>
                                  <span v-if="sv.bookingServiceRates.length > 0" class="fs-12 text-secondary">(
                                    <template v-for="(date, i) in sv.bookingServiceRates">
                                      <template v-if="i < sv.bookingServiceRates.length - 1">
                                        {{
                                          _formatDateTime(
                                            date.appliedDate,
                                            "YYYY-MM-DD",
                                            "DD/MM/YYYY"
                                          )
                                        }},
                                      </template>
                                      <template v-else>
                                        {{
                                          _formatDateTime(
                                            date.appliedDate,
                                            "YYYY-MM-DD",
                                            "DD/MM/YYYY"
                                          )
                                        }}
                                      </template>
                                    </template>
                                    )
                                  </span>
                                </b-col>
                                <b-col class="pt-0 pb-0 text-right" cols="4"><span>{{
                                  formatCurrency(+sv.amount / sv.quantity)
                                }}</span></b-col>
                                <b-col class="pt-0 pb-0 text-right" cols="2"><span>{{ sv.quantity }}</span></b-col>
                                <b-col class="pt-0 pb-0 text-right" cols="2"><u v-if="sv.includedRate"
                                    class="cursor" :title="$t('SERVICE.BINDING_PRICE')">{{ formatCurrency(sv.amount)
                                    }}</u> <span v-else>{{
  formatCurrency(sv.amount) }}</span></b-col>
                              </b-row>
                            </template>

                          </template>

                        </b-col>
                      </b-row>
                    </div>
                  </div>
                  <template v-if="data.bookingLines.filter(
                    y => y.ratePlan.id == rateplanid && y.bookingLineType == 1
                  ).length > 0
                    ">
                    <b-row class="m-0 mb-3 item-promotion text-success">
                      <b-col class="p-0" md="4">
                        <p class="m-0 fs-16">
                          <span class="font-weight-bold">
                            {{ $t("PROMOTION_INFO") }}
                          </span>
                        </p>
                      </b-col>
                      <b-col class="p-0">
                        <b-row v-for="(inc, indexsv) in data.bookingLines.filter(
                            y => y.ratePlan.id == rateplanid && y.bookingLineType == 1
                          )" :key="indexsv">
                          <b-col class="pt-0 pb-0">
                            <span class="d-flex">
                              {{ inc.title }} ({{inc.roomType.roomTypeI18n.find(z => z.lang == defaultI18n).name}})
                              <v-icon v-if="inc.bookingRates.length > 0" color="primary" dark class="pl-1 cursor"
                                size="18" :id="rateplanid + indexsv + index + 'km'">
                                info
                              </v-icon>
                            </span>
                            <b-popover :target="rateplanid + indexsv + index + 'km'" triggers="hover focus"
                              v-if="inc.bookingRates.length > 0">
                              <template #title>{{ $t('DETAIL') }}</template>
                              <div class="description-price">
                                <div v-for="(i, index) in inc.bookingRates" :key="index">
                                  <template v-if="sysLang == 'vi'">
                                    {{ _formatDateTime(i.appliedDate, "YYYY-MM-DD", "DD/MM/YYYY") }}
                                  </template>
                                  <template v-else>
                                    {{ _formatDateTime(i.appliedDate, "YYYY-MM-DD", "DD/MM/YYYY") }}
                                  </template>
                                  : &nbsp; {{ formatCurrency(+i.pricePax) }}
                                </div>
                              </div>
                            </b-popover>
                          </b-col>
                          <b-col class="pt-0 pb-0 text-right" cols="2"></b-col>
                          <b-col class="pt-0 pb-0 text-right" cols="2"></b-col>
                          <b-col class="pt-0 pb-0 text-right text-success" cols="2"><span>{{ formatCurrency(inc.lineTotal)
                          }}</span></b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </template>
                  <p class="border-bottom"></p>
                </div>
                <div class="px-3">
                  <b-row class="m-0">
                    <b-col md="9"></b-col>
                    <b-col class="p-0"><span class="font-weight-bold">{{ $t("_BOOKING_DETAIL.SUB_TOTAL")
                    }}:</span></b-col>
                    <b-col class="text-right p-0"><span class="font-weight-bold">
                        {{ formatCurrency(subTotal) }}
                      </span></b-col>
                  </b-row>
                  <b-row class="m-0">
                    <b-col md="9"></b-col>
                    <b-col class="p-0"><span class="font-weight-bold">{{ $t("SERVICE.TAX_LABEL") }}:</span></b-col>
                    <b-col class="text-right p-0"><span class="font-weight-bold">
                        {{ formatCurrency(data.amountTax, data.currencyCode) }}
                      </span></b-col>
                  </b-row>

                  <b-row class="m-0 text-success">
                    <b-col md="9"></b-col>
                    <b-col class="p-0"><span class="font-weight-bold">{{ $t("_BOOKING_DETAIL.PROMOTION.TITLE")
                    }}:</span></b-col>
                    <b-col class="text-right p-0"><span class="font-weight-bold">
                        {{ formatCurrency(totalPromotion) }}
                      </span></b-col>
                  </b-row>
                  <b-row class="m-0">
                    <b-col md="9"></b-col>
                    <b-col class="p-0"><span class="font-weight-bold">{{
                      $t("_BOOKING_DETAIL.TOTAL")
                    }}</span></b-col>
                    <b-col class="text-right p-0"><span class="font-weight-bold">
                        {{ formatCurrency(data.amount) }}
                      </span></b-col>
                  </b-row>
                  <b-row class="m-0">
                    <b-col md="9"></b-col>
                    <b-col class="p-0"><span class="font-weight-bold">{{
                      $t("_BOOKING_DETAIL.COMMISSION")
                    }}</span></b-col>
                    <b-col class="text-right p-0"><span class="font-weight-bold">
                        {{ data.commission ? formatCurrency(data.commission,) : 'N/A' }}
                      </span></b-col>
                  </b-row>
                  <b-row class="m-0">
                    <b-col md="9"></b-col>
                    <b-col class="p-0">
                      <span class="font-weight-bold">
                        {{$t("_BOOKING_DETAIL.BEFORE_COMMISSION")}}
                      </span>
                    </b-col>
                    <b-col class="text-right p-0">
                      <span class="font-weight-bold">
                        {{ data.priceBeforeCommission ? formatCurrency(data.priceBeforeCommission,) : 'N/A' }}
                      </span>
                    </b-col>
                  </b-row>
                  <b-row class="m-0">
                    <b-col md="9" class="p-0">
                      <span class="text-danger fs-11" style="font-size: 11px;">{{ $t('COMMISSION_RATE_NOTE') }}</span>
                    </b-col>
                    <b-col class="p-0">
                      <span class="font-weight-bold">
                        {{$t("_BOOKING_DETAIL.AFTER_COMMISSION")}}
                      </span>
                    </b-col>
                    <b-col class="text-right p-0">
                      <span class="font-weight-bold">
                        {{ data.priceAfterCommission ? formatCurrency(data.priceAfterCommission,) : 'N/A' }}
                      </span>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </v-card>
          </div>
          <div class="mt-3">
            <v-card class="h-100 border" elevation="0">
              <label class="label-title mx-3 mt-3 mb-2">{{ $t("PAYMENT_HISTORY") }}</label>
              <div class="border-top-unset">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          {{ $t('PAYMENT_CODE') }}
                        </th>
                        <th class="text-left w-20">
                          {{ $t("_BOOKING_TRANSACTION_DETAIL.PAYMENT_METHOD") }}
                        </th>
                        <th class="text-left">
                          {{ $t("_BOOKING_TRANSACTION_DETAIL.TRANSACTION_CODE") }}
                        </th>
                        <th class="text-left">
                          {{ $t("EZPAYREF") }}
                        </th>
                        <th>
                          {{ $t("PAYMENT_TYPE") }}
                        </th>
                        <th class="text-left">
                          {{ $t("_BOOKING_TRANSACTION_DETAIL.AMOUNT") }}
                        </th>
                        <th class="text-center w-20">
                          {{ $t("_BOOKING_TRANSACTION_DETAIL.TRANSACTION_DATE") }}
                        </th>
                        <th>
                          {{ $t("PAYMENT_STATUS") }}
                        </th>
                        <th class="text-right w-20">
                          {{ $t("_BOOKING_TRANSACTION_DETAIL.NOTE") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in data.bookingPayments" :key="item.transactionDate">
                        <td class="text-nowrap">{{ item.transactionRef }}</td>
                        <td>{{ item.paymentMethod }}</td>
                        <td>{{ item.transactionNo }}</td>
                        <td>{{ item.ezpayRef }}</td>
                        <td class="text-nowrap">{{ paymentTypeOption.find(x => x.code === item.paymentType).text }}</td>
                        <td>
                          {{ formatCurrency(item.amount) }}
                        </td>
                        <td class="text-center">
                          {{ formatDateTime(item.transactionDate) }}
                        </td>
                        <td class="text-nowrap">{{ paymentStatusOption.find(x => x.code === item.paymentStatus).text }}
                        </td>
                        <td class="text-right" style="min-width: 130px;">{{ item.note }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <v-row class="mx-0">
                  <v-col md="9" class="text-right"> </v-col>
                  <v-col md="3" class="text-right">
                    <div class="d-flex justify-space-between">
                      <span>{{ $t("HOTEL_LOG_payableAmount") }}: </span>
                      <span class="font-weight-bold">{{ formatCurrency(this.totalBookingPayment) }}
                      </span>
                    </div>
                    <div class="d-flex justify-space-between">
                      <span>{{ $t("_BOOKING_DETAIL.UNPAID") }} </span>
                      <span class="font-weight-bold">{{
                        formatCurrency(
                          this.data.amount - this.totalBookingPayment
                        )
                      }}
                      </span>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </div>
          <div class="mt-3" v-if="data.bookingLogs.length > 0">
            <v-card class="h-100 border" elevation="0">
             <div class="d-flex justify-content-between align-items-center">
              <label class="label-title mx-3 mt-3 mb-2">{{ $t("BOOKING_HISTORY") }}</label>
             </div>
              <div class="">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          {{ $t('BOOKING_STATUS_OTA') }}
                        </th>
                        <th class="text-left w-20">
                          {{ $t("_BOOKING_DETAIL.PAYMENT_LOG.TRANS_DATE") }}
                        </th>
                        <th class="text-right">
                          {{ $t("DETAIL") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in data.bookingLogs" :key="index">
                        <td class="text-nowrap">{{ $t('BOOKING_OTA_STATUS_' + item.otaBookingStatus) }}</td>
                        <td>{{ formatDateTime(item.createdDate) }}</td>
                        <td class="text-right">
                          <v-btn class="pl-5 pr-5" color="primary" small @click="detailLogData(item)" outlined>
                            {{ $t("DETAIL") }}
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </v-card>
          </div>
          <div class="text-right mt-3" v-if="!code">
            <v-btn class="pl-5 pr-5" color="primary" @click="back">
              {{ $t("BACK") }}
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <v-dialog v-if="!code" v-model="dialogNote" width="600px">
      <v-card class="p-1">
        <v-card-title>
          <span class="text-h6">{{
            $t('_BOOKING_DETAIL.BOOKING_DETAIL.NOTE')
          }}</span>
        </v-card-title>
        <v-card-text class="fs-12 text-dark" v-html="textNote.replace(/\n/g, '<br>')">
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogNote = false">
            {{ $t('CLOSE') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div v-if="dialogNote && code" class="fullscreen-overlay" @click.self="dialogNote = false">
      <v-card class="alert-card p-0" width="600px" style="border-radius: 5px;">
        <v-card-title>
          <span class="text-h6">{{
            $t('_BOOKING_DETAIL.BOOKING_DETAIL.NOTE')
          }}</span>
        </v-card-title>
        <v-card-text class="fs-12 text-dark" v-html="textNote.replace(/\n/g, '<br>')">
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogNote = false">
            {{ $t('CLOSE') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
    <v-dialog v-if="!code" v-model="dialog" hide-overlay transition="dialog-bottom-transition" max-width="1000px">
      <v-card class="overflow-hidden p-0">
        <v-app-bar absolute color="#fafafa" elevate-on-scroll scroll-target="#scrolling-techniques-7">
          <v-toolbar-title class="label-title">{{ $t("DETAIL") }}</v-toolbar-title>
        </v-app-bar>
        <v-sheet id="scrolling-techniques-7" class="overflow-y-auto fs-12 sheet-log" max-height="600">
          <v-container class="mt-3">
            <label class="label-title">Request body: </label>
            <div class="ml-3" v-if="detailLog">
              <pre>{{
                JSON.parse(detailLog)
              }}</pre>
            </div>
            
          </v-container>
        </v-sheet>
      </v-card>
    </v-dialog>
    <div v-if="dialog && code" class="fullscreen-overlay" @click.self="dialog = false">
      <v-card class="alert-card p-0" width="800px" style="border-radius: 5px;">
        <v-app-bar absolute color="#fafafa" elevate-on-scroll scroll-target="#scrolling-techniques-7">
          <v-toolbar-title class="label-title">{{ $t("DETAIL") }}</v-toolbar-title>
        </v-app-bar>
        <v-sheet id="scrolling-techniques-7" class="overflow-y-auto fs-12 sheet-log" max-height="600">
          <v-container class="mt-3">
            <label class="label-title">Request body: </label>
            <div class="ml-3" v-if="detailLog">
              <pre>{{
                JSON.parse(detailLog)
              }}</pre>
            </div>
            
          </v-container>
        </v-sheet>
      </v-card>
    </div>
  </div>
</template>
  
<style lang="scss" scoped>
.headertableDetail {
  background: #fafafa;
}

.line-break {
  border-top: 1px dashed #ece7e7;
  padding: 5px 0;
}

.booking-line {
  .item {
    border-bottom: 1px solid #ecebeb;
    padding-bottom: 5px;
    margin-bottom: 5px;

    &:last-child {
      border: none;
      padding-bottom: 0;
      margin-bottom: 0;
    }
  }
}

.col-12 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}

.warn-text-container {
  margin-top: 10px;
}

.warn-text {
  display: inline-block;
  color: #d9390d;
  width: 80%;
}

.text-count {
  position: relative;
  top: 2px;
  float: right;
  display: inline-block;
}

.item-rateplan>div {
  border-bottom: 1px dashed #fbc27a8c;
  margin-bottom: 10px;

  &:last-child {
    border: none;
  }
}

.item-promotion {
  border-top: 1px dashed #28a74536;
  padding-top: 10px !important;
}
</style>
  
<script>
import { getBkDtError } from "@/_helpers/config.js";
import {
  _validateFormI18n,
  _alert,
  _formatDateTimeUTCToLocal,
  _formatCurrency
} from "@/_helpers/function.js";
import { chainService } from "@/_services/ChainManage/chain.service.js";
import printJS from "print-js";
import moment from "moment";

export default {
  props: {
    code: {
      type: [String, Number],
      default: null,
    },
  },
  components: {},
  data() {
    return {
      dialog: false,
      detailLog: null,
      subTotal: 0,
      totalPromotion: 0,
      bookingGroup: [],
      totalBookingPayment: 0,
      sysLang: this.$i18n.locale,
      maxCount: 255,
      remainingCount: 255,
      currentCount: 0,
      disable: false,
      hasError: false,
      isLoading: false,
      data: {},
      headers: [
        {
          text: this.$t("STT"),
          class: "text-center"
        },
        {
          text: this.$t("SALE_PACKAGE"),
          value: "name"
        },
        {
          text: this.$t("_BOOKING_DETAIL.ROOM.APPLY_DATE"),
          value: "price",
          class: "text-center"
        },
        {
          text: this.$t("_BOOKING_DETAIL.ROOM.ADULTS"),
          value: "quantity",
          class: "text-center"
        },
        {
          text: this.$t("_BOOKING_DETAIL.ROOM.CHILDREN"),
          value: "total",
          class: "text-center"
        },
        {
          text: this.$t("_BOOKING_DETAIL.ROOM.BABY"),
          value: "total",
          class: "text-center"
        },
        {
          text: this.$t("TOTAL"),
          value: "total",
          class: "text-right"
        }
      ],
      listBookingStatus: [
        {
          value: null,
          text: this.$t("ALL")
        },
        {
          value: 0,
          text: this.$t("_BOOKING.STATUS.AWAIT_PAYMENT"),
          color: "rgb(254, 209, 47)"
        },
        {
          value: 1,
          text: this.$t("_BOOKING.STATUS.CONFIRM"),
          color: "#0da313"
        },
        {
          value: 2,
          text: this.$t("_BOOKING.STATUS.CANCEL"),
          color: "#808080"
        },
        {
          value: 3,
          text: this.$t("_BOOKING.STATUS.VOID"),
          color: "#262626"
        },
        {
          value: 4,
          text: this.$t("_BOOKING.STATUS.IN_SERVICE"),
          color: "#262626"
        },
        {
          value: 5,
          text: this.$t("_BOOKING.STATUS.CLOSE"),
          color: "#262626"
        },
        {
          value: 6,
          text: this.$t("_BOOKING.STATUS.PAYMENT_FAILED"),
          color: "#ff0000"
        },
        {
          value: 7,
          text: this.$t("_BOOKING.STATUS.AWAIT_FULLY_PAYMENT"),
          color: "#fed12f"
        }
      ],
      // contractMayCancelStatus: [2, 5, 6, 7],
      contractMayCancelStatus: [
        "AWAIT_PAYMENT",
        "PAYMENT_FAILED",
        "CONFIRM",
        "AWAIT_FULLY_PAYMENT"
      ],
      dataCancel: {
        reason: ""
      },
      error: getBkDtError(),
      isContractCancel: false,
      deactiveDialog: false,
      paymentTypeOption: [
        {
          code: 0,
          text: this.$t('PAYMENT')
        },
        {
          code: 1,
          text: this.$t('REFUND')
        },

        {
          code: 2,
          text: this.$t('CANCELLATION_REFUND')
        },
        {
          code: 3,
          text: this.$t('CANCELLATION_FEE')
        }
      ],
      paymentStatusOption: [
        {
          code: 0,
          text: this.$t('WAITING_PAYMENT')
        },
        {
          code: 1,
          text: this.$t('SUCCESS_PAYMENT')
        },

        {
          code: 2,
          text: this.$t('FAILED')
        }
      ],
      dialogNote: false,
      textNote: "",
      toogleShowInvoice: false
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    detailLogData(data) {
          this.detailLog = data.content;
          this.dialog = true;
    },
    openPopupNote(value) {
      this.textNote = value;
      this.dialogNote = true;
    },
    groupBy(xs, key) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    sumPrice(array, key) {
      if (!Array.isArray(array)) return 'N/A'
      let hasValue = false
      const total = array.reduce((acc, item) => {
        if (!item || item[key] === null || item[key] === undefined) {
          return acc
        }
        const value = Number(item[key])
        if (!isNaN(value)) {
          hasValue = true
          return acc + value
        }
        return acc
      }, 0)
      return hasValue ? this.formatCurrency(total) : 'N/A'
    },
    _formatDateTimeUTCToLocal(value, inputFormat, outputFormat) {
      if (!value) {
        return "";
      }
      return _formatDateTimeUTCToLocal(value, inputFormat, outputFormat);
    },
    _formatDateTime(value, inputFormat, outputFormat) {
      if (!value) {
        return "";
      }
      return moment(value).format(outputFormat);
    },
    formatCurrency(amount) {
      return _formatCurrency(amount, this.data.currencyCode);
    },
    sortBookingLineType(a, b) {
      return parseFloat(a.bookingLineType) - parseFloat(b.bookingLineType);
    },
    // Run when start
    initialize() {
      let requests = [];
      if (this.code == null && (!this.$route.params || !this.$route.params.code)) {
        this.back();
      }
      this.data.code = this.code || this.$route.params.code;
      requests.push(this.getBookingDetail(this.data.code));
      this.isLoading = true;
      Promise.all(requests).finally(() => (this.isLoading = false));
    },
    // Go back
    back() {
      this.$router.back();
    },
    // Get booking status text
    getBookingStatusText(key) {
      const result = this.listBookingStatus.find(item => item.value === key);
      return result ? result.key : "";
    },
    showPromotion(description) {
      let data = description.split("|");
      let start = "";
      let end = "";
      if (this.sysLang == "vi") {
        start = _formatDateTimeUTCToLocal(data[1], "YYYY-MM-DD", "DD/MM/YYYY");
        end = _formatDateTimeUTCToLocal(data[2], "YYYY-MM-DD", "DD/MM/YYYY");
      } else {
        start = _formatDateTimeUTCToLocal(
          data[1],
          "YYYY-MM-DD hh:mm A",
          "YYYY/MM/DD HH:mm"
        );

        end = _formatDateTimeUTCToLocal(data[2], "YYYY-MM-DD", "DD/MM/YYYY");
      }

      return (
        '<span class="font-weight-bold">' +
        this.$t("PROMOTION") +
        ": " +
        data[0] +
        "</span><br><span>" +
        this.$t("_BOOKING_DETAIL.ROOM.APPLY_DATE") +
        ": " +
        start +
        " - " +
        end +
        "</span>"
      );
    },
    showService(description) {
      let data = description.split("|");
      let start = "";
      let end = "";
      if (this.sysLang == "vi") {
        start = _formatDateTimeUTCToLocal(data[1], "YYYY-MM-DD", "DD/MM/YYYY");
        end = _formatDateTimeUTCToLocal(data[2], "YYYY-MM-DD", "DD/MM/YYYY");
      } else {
        start = _formatDateTimeUTCToLocal(
          data[1],
          "YYYY-MM-DD hh:mm A",
          "YYYY/MM/DD HH:mm"
        );

        end = _formatDateTimeUTCToLocal(data[2], "YYYY-MM-DD", "DD/MM/YYYY");
      }

      return (
        '<span class="font-weight-bold">' +
        this.$t("SERVICES") +
        ": " +
        data[0] +
        "</span><br><span>" +
        this.$t("_BOOKING_DETAIL.ROOM.APPLY_DATE") +
        ": " +
        start +
        " - " +
        end +
        "</span>"
      );
    },
    // load booking detail
    async getBookingDetail(code) {
      this.subTotal = 0;
      return await chainService.getBookingDetail(code).then(res => {
        if (res.responseCode === 0) {
          this.data = res.data;

          this.data.bookingPayments.forEach(x => {
            if (x.paymentStatus === 1) {
              this.totalBookingPayment = this.totalBookingPayment + x.amount;
            }
          });

          // Nhóm bookingline
          const booking_line_rateplan_id = [];
          this.data.bookingLines.forEach((element, index) => {
            if (element.bookingLineType === 0) {
              booking_line_rateplan_id.push(element.ratePlan.id);
              element.serviceStatic = element.bookingServices.length > 0 ? element.bookingServices.filter(sv => sv.serviceType === 1) : [];
              
              this.subTotal += element.amountPax;
              if (element.extraAdults > 0) {
                  this.subTotal += element.amountExtraAdult;
              }

              if (element.extraBaby > 0) {
                  this.subTotal += element.amountExtraBaby;
              }

              if (element.extraChildren > 0) {
                  this.subTotal += element.amountExtraChildren;
              }
              
              this.subTotal += element.bookingServices.reduce((sum, e) => {
                  if (e.serviceType !== 1 && e.includedRate == false) {
                  return sum + Number(e.amount || 0);
                  }
                  return sum;
              }, 0);
            }
          });

          // Xoá các rateplandid trùng lặp
          this.bookingGroup = [
            ...Array.from(new Set(booking_line_rateplan_id))
          ];

          // totalPromotion
          this.data.bookingLines.forEach((element, index) => {
            if (element.bookingLineType === 1) {
              // console.log(element.lineTotal);
              this.totalPromotion = +this.totalPromotion + +element.lineTotal;
            }
          });

          // Check booking status
          if (this.contractMayCancelStatus.indexOf(this.data.status) > -1 && this.data.otaCode === 'EZ_BE') {
            this.isContractCancel = true;
          } else {
            this.isContractCancel = false;
          }
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });
    },
    // print booking
    printBooking() {
      // printJS({ printable: 'printSection', type: 'html', targetStyles: ['*'] });
      // Get HTML to print from element
      const prtHtml = document.getElementById("printSection").innerHTML;
      // Get all stylesheets HTML
      let stylesHtml = `<style type="text/css">.not-print {display: none}</style>`;
      // Open the print window
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=0,height=0,toolbar=0,scrollbars=0,status=0"
      );
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            ${stylesHtml}
            ${getCssText()}
          </head>
          <body style="padding: 20px; background: #f6f6f6; visible: hidden;">
            ${prtHtml}
          </body>
        </html>`);
      WinPrint.document.close();
      this.$nextTick().then(() => {
        WinPrint.focus();
        WinPrint.print();
        WinPrint.close();
      });
    },
    countdown() {
      this.remainingCount = this.maxCount - this.dataCancel.reason.length;
      this.currentCount = this.dataCancel.reason.length;
    },
    // Validate booking, then cancel
    validateCancelBooking() {
      let { isValid, error } = _validateFormI18n(this.dataCancel, this.error);
      this.error = error;
      if (!isValid) return false;
      this.cancelBooking(this.data.code, this.dataCancel.reason);
    },
    // Cancel booking
    cancelBooking(code, reason) {
      let temp = {
        code: code,
        reason: reason
      };
      this.isLoading = true;
      service
        .cancelBooking(temp)
        .then(res => {
          if (res.responseCode === 0) {
            // this.initialize();
            _alert(res, this.$t(res.data));
          } else {
            this.deactiveDialog = false;
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => (this.isLoading = false));
    },
    getStatusColor(status) {
      const selected = this.listBookingStatus.find(item => item.key === status);
      return selected ? selected.color : status;
    },
    _moment: moment
  }
};
</script>
<style lang="scss" scoped>
.room-card {
  .row {
    .col {
      &:nth-of-type(1) {
        width: 16%;
        max-width: 16%;
      }

      &:nth-of-type(2) {
        width: 16%;
        max-width: 16%;
      }

      &:nth-of-type(3) {
        width: 16%;
        max-width: 16%;
      }

      &:nth-of-type(4) {
        width: 16%;
        max-width: 16%;
      }

      &:nth-of-type(5) {
        width: 10%;
        max-width: 10%;
      }

      &:nth-of-type(6) {
        width: 10%;
        max-width: 10%;
      }

      &:nth-of-type(7) {
        width: 16%;
        max-width: 16%;
      }
    }
  }
}

.payment-history-card {
  .row {
    .col {
      &:nth-of-type(1) {
        width: 22%;
        max-width: 22%;
      }

      &:nth-of-type(2) {
        width: 16%;
        max-width: 16%;
      }

      &:nth-of-type(3) {
        width: 26%;
        max-width: 26%;
      }

      &:nth-of-type(4) {
        width: 12%;
        max-width: 12%;
      }

      &:nth-of-type(5) {
        width: 25%;
        max-width: 25%;
      }
    }
  }
}

.border-right {
  border-right: solid thin rgba(0, 0, 0, 0.12) !important;
}
</style>
  